<div class="wrapper" [ngClass]="size">
  <input
    [attr.id]="controlId ?? generatedRandomId"
    [disabled]="disabled"
    [checked]="isChecked"
    type="checkbox"
    (change)="toggleCheckbox()" />
  <label [for]="controlId ?? generatedRandomId" aria-hidden="true"></label>
</div>
